<template>
    <div class="summary-table-query-side-panel">
        <div class="section">
            <div class="title">搜尋</div>

            <el-radio-group v-model="queryTimeType" @change="onQueryTimeTypeChange" style="margin-bottom: 20px;">
                <el-radio-button :label="1">發票開立期別</el-radio-button>
                <el-radio-button :label="2">申報期別</el-radio-button>
            </el-radio-group>
            <div class="manipulate">
                <el-select v-if="queryTimeType === 2" v-model="period" placeholder="請選擇" style="width: 100%; margin-bottom: 15px;" value-key="key" @change="onQueryChange">
                    <el-option v-for="item in periodList" :key="`${item.year}-${item.value}-${item.period}`" :label="`${item.year - 1911}年 ${item.period}`" :value="item" />
                </el-select>
                <el-radio-group v-model="queryType" class="status-selection-section" @change="onQueryChange">
                    <el-radio :label="1">
                        銷項 <span v-if="queryTimeType === 2">({{ declaredInvoiceItems }})</span>
                    </el-radio>
                    <el-radio :label="2">
                        進項 <span v-if="queryTimeType === 2">({{ declaredPaymentItems }})</span>
                    </el-radio>
                    <el-radio v-if="isPayed('D21')" :label="3">
                        外部進項 <span v-if="queryTimeType === 2">({{ declaredPaymentInvoiceItems }})</span>
                    </el-radio>
                </el-radio-group>
                <el-select v-if="queryTimeType === 1" v-model="period" placeholder="請選擇" style="width: 100%; margin-top: 15px;" value-key="key" @change="onQueryChange">
                    <el-option v-for="item in periodList" :key="`${item.year}-${item.value}-${item.period}`" :label="`${item.year - 1911}年 ${item.period}`" :value="item" />
                </el-select>
            </div>
        </div>
        <div class="section no-bottom" v-if="queryTimeType === 1">
            <div class="title">{{ queryType === 1 ? "銷項" : "進項" }}狀態</div>
            <div class="manipulate">
                <el-radio-group v-model="status" class="status-selection-section" @change="onQueryChange">
                    <el-radio v-for="radio in statusMap" :key="`401-summary-table-query-side-panel-status-selection-${radio.id}`" :label="radio.value">
                        <span
                            >{{ radio.label }}<ah-tip v-if="radio.description">{{ radio.description }}</ah-tip
                            >（{{ radio.count }}）</span
                        >
                        <!-- <div v-if="radio.description" class="description">{{ radio.description }}</div> -->
                    </el-radio>
                </el-radio-group>
            </div>
        </div>
        <!-- <div>
            <el-button class="btn" type="primary" @click="onSubmit">搜尋</el-button>
        </div> -->
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    data() {
        return {
            period: null,
            queryTimeType: 1,
            queryType: 1, // 1 發票收入(銷項) 2 請款支出(進項)
            status: 1,
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapState({
            queryParams: (state) => state.businessTax.queryParams,
            periodList: (state) => state.businessTax.periodList,
            storePeriod: (state) => state.businessTax.period,
            storePeriodYear: (state) => state.businessTax.periodYear,
            dataCount: (state) => state.businessTax.dataCount,

            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems.length,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems.filter((o) => !o.taxCredited).length,
            declaredPaymentInvoiceItems: (state) => state.businessTax.declaredPaymentItems.filter((o) => !!o.taxCredited).length,
        }),
        statusMap() {
            if (this.queryType === 1) {
                return [
                    {
                        label: '未申報',
                        id: 'undeclared',
                        value: 1,
                        count: this.queryType === this.queryParams.QueryType ? this.dataCount.undeclared : '--',
                        description: null,
                    },
                    {
                        label: '已申報',
                        id: 'declared',
                        value: 2,
                        count: this.queryType === this.queryParams.QueryType ? this.dataCount.declared : '--',
                        description: null,
                    },
                    {
                        label: '零稅率',
                        id: 'zero-tax',
                        value: 3,
                        count: this.queryType === this.queryParams.QueryType ? this.dataCount.other1 : '--',
                        description: 'INVOICE 境外收入，非經海關出口應附證明文件',
                    },
                    {
                        label: '免申報',
                        id: 'no-need-declare',
                        value: 4,
                        count: this.queryType === this.queryParams.QueryType ? this.dataCount.other2 : '--',
                        description: '核銷收入',
                    },
                ];
            }
            return [
                {
                    label: '未申報',
                    id: 'undeclared',
                    value: 1,
                    count: this.queryType === this.queryParams.QueryType ? this.dataCount.undeclared : '--',
                    description: null,
                },
                {
                    label: '已申報',
                    id: 'declared',
                    value: 2,
                    count: this.queryType === this.queryParams.QueryType ? this.dataCount.declared : '--',
                    description: null,
                },
                {
                    label: '不申報扣抵',
                    id: 'not-declare',
                    value: 3,
                    count: this.queryType === this.queryParams.QueryType ? this.dataCount.other1 : '--',
                    description: '交際應酬、員工福利費用',
                },
                {
                    label: '不能申報的其他單據',
                    id: 'invalid',
                    value: 4,
                    count: this.queryType === this.queryParams.QueryType ? this.dataCount.other2 : '--',
                    description: '收據、勞務單、合約、其他證明',
                },
            ];
        },
    },
    methods: {
        ...mapMutations({
            updateQuery: 'businessTax/updateQuery',
            setDeclarePeriod: 'businessTax/setDeclarePeriod',
            onClearSelection: 'businessTax/onClearSelection',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
            updateDeclaredData: 'businessTax/updateDeclaredData',
        }),
        init() {
            this.period = this.periodList.find((o) => o.value === this.storePeriod && o.year === this.storePeriodYear);
            this.queryTimeType = this.queryParams.SearchType;
            this.queryType = this.queryParams.QueryType;
            this.status = this.queryParams.TaxDeclareStatus;

            this.setDeclarePeriod(this.period);
            this.updateDeclaredData();
        },
        onSubmit() {
            if (this.queryTimeType === 2) this.status = 2;

            this.updateQuery({
                period: this.period,
                SearchType: this.queryTimeType,
                QueryType: this.queryType,
                TaxDeclareStatus: this.status,
                Foo: this.queryParams.Foo,
                Bsn: this.queryParams.Bsn,
                Amt: this.queryParams.Amt,
            });
            this.updateData();
        },
        onQueryChange() {
            this.onSubmit();
            this.setDeclarePeriod(this.period);
            this.updateDeclaredData();
        },
        onQueryTimeTypeChange(type) {
            if (type === 1) {
                this.status = 1;
                this.queryType = 1;
            }
            if (type === 2) {
                this.status = 2;
                this.queryType = 1;
            }
            this.onClearSelection();
            this.onQueryChange();
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
.summary-table-query-side-panel {
    width: 284px;
    min-width: 284px;
    border-right: 1px solid #e1e1e1;
    padding: 25px 20px;

    .section {
        border-bottom: 1px solid #e1e1e1;
        padding: 20px 10px;
        font-weight: bold;
        &:first-child {
            padding-top: 0;
        }
        &.no-bottom {
            border-bottom: 0;
        }
        .title {
            color: $main-color;
            margin-bottom: 15px;
        }
        .el-radio {
            // font-weight: bold;

            &.is-checked {
                font-weight: bold;
            }
        }
    }
    .btn {
        margin-top: 10px;
        width: 100%;
    }

    .status-selection-section {
        display: flex;
        flex-direction: column;
        .el-radio {
            margin: 6px 0;
        }
        .description {
            color: #000;
            margin-left: 25px;
            font-size: 8pt;
        }
    }
}
</style>
